import { storeHomeNVClient, ImResponse } from '.';

export interface JolectAuthShopParams {
  code: string; // 对应前端输入的「店铺 Token」
  departmentIds: number[];
}

export interface JolectAuthShopResponse {
  errorCode: number;
  errorMsg: string;
  isSuccess: boolean;
  productLine: string;
}

export const authJolectShop = (params: JolectAuthShopParams) =>
  storeHomeNVClient.post<ImResponse<JolectAuthShopResponse>>('/auth/jolect/shop', params);
